import React from 'react';
import { aboutData } from '../mock';
import { Check } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-5xl md:text-6xl font-bold text-[#1a1a2e] tracking-tight">
                {aboutData.title}
              </h2>
              <p className="text-xl text-[#dc143c] font-semibold tracking-wider">{aboutData.since}</p>
              <div className="w-24 h-1 bg-[#dc143c]"></div>
            </div>

            <p className="text-lg text-[#666] leading-relaxed">
              {aboutData.description}
            </p>

            <p className="text-lg text-[#666] leading-relaxed">
              {aboutData.mission}
            </p>

            <div className="space-y-4 pt-4">
              <h3 className="text-2xl font-bold text-[#1a1a2e]">Our Values</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {aboutData.values.map((value, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-8 h-8 bg-[#dc143c] rounded-full flex items-center justify-center">
                      <Check size={16} className="text-white" />
                    </div>
                    <span className="text-base text-[#1a1a2e] font-medium">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src="https://images.unsplash.com/photo-1760302318631-a8d342cd4951"
                  alt="Showroom"
                  className="w-full h-64 object-cover rounded-sm shadow-lg"
                />
                <img
                  src="https://images.unsplash.com/photo-1698664434415-03203ce8acc7"
                  alt="Collection"
                  className="w-full h-48 object-cover rounded-sm shadow-lg"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img
                  src="https://images.unsplash.com/photo-1581101767113-1677fc2beaa8"
                  alt="Luxury shoes"
                  className="w-full h-48 object-cover rounded-sm shadow-lg"
                />
                <img
                  src="https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg"
                  alt="Men's collection"
                  className="w-full h-64 object-cover rounded-sm shadow-lg"
                />
              </div>
            </div>

            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-[#dc143c] rounded-full blur-3xl opacity-20 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
